import { lazy } from 'react';

export const ClaimsList = lazy(() => import('./pages/ClaimsList'));
export const ClaimDetail = lazy(() => import('./pages/ClaimDetail'));
export const PaymentVoucher = lazy(() => import('./pages/PaymentVoucher'));
export const ClaimsFinanceQueue = lazy(() => import('./pages/ClaimsFinanceQueue'));
export const ClaimsF5Export = lazy(() => import('./pages/ClaimsF5Export'));

export { CLAIM_ROUTES } from './paths';
